import { render } from "./TripRidersPage.vue?vue&type=template&id=2d16cbbc&scoped=true"
import script from "./TripRidersPage.vue?vue&type=script&lang=ts"
export * from "./TripRidersPage.vue?vue&type=script&lang=ts"

import "./TripRidersPage.vue?vue&type=style&index=0&id=2d16cbbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d16cbbc"

export default script